import React from "react";
import { useField } from "formik";
import { findField } from "@app/utils/form";
import Config from "@app/constants/Config";

const listCategories = {
	physische_gefährdung: {
		selectorKey: "physischegefaehrdungsanalyse_kategorie_kategorie",
		selectorValue: "physische_gefährdung",
		displayKey: "physischegefaehrdungsanalyse_gefaehrdungstyp_physische_gefaehrdung",
	},
	einfluss_am_tätigkeitsort: {
		selectorKey: "physischegefaehrdungsanalyse_kategorie_kategorie",
		selectorValue: "einfluss_am_tätigkeitsort",
		displayKey: "physischegefaehrdungsanalyse_gefaehrdungstyp_einflussamtaetigkeitsort",
	},
	gefahrenstoff: {
		selectorKey: "physischegefaehrdungsanalyse_kategorie_kategorie",
		selectorValue: "gefahrenstoff",
		displayKey: "physischegefaehrdungsanalyse_gefaehrdungstyp_gefahrenstoff",
	},
};

export function RemainingHazardsMessage({ name, hasMinCountError }) {
	const [{ value }] = useField({ name });
	const arr = Array.isArray(value) ? value : [];
	const remaining = Math.max(0, Config.DANGER_MIN_COUNT - arr.length);

	if (!hasMinCountError || remaining <= 0) {
		return null;
	}

	return (
		<div className="mt-18">
			<div className="text-danger">
				{remaining === 1
					? "Es muss noch 1 Gefährdung angelegt werden."
					: `Es müssen noch ${remaining} Gefährdungen angelegt werden.`}
			</div>
		</div>
	);
}

export const useDangerListObserver = (currentFieldsets) => {
	const dangerListField = findField(currentFieldsets, "physischegefaehrdungsanalyse_gefaehrdungen_gefaehrdungen");
	let res = React.useMemo(() => {
		if (dangerListField) {
			const categories = findField(
				dangerListField.formPage?.fieldsets,
				"physischegefaehrdungsanalyse_kategorie_kategorie",
			)?.options;
			dangerListField.listCategories = categories.map((category) => ({
				listLabel: category.label,
				...listCategories[category.value],
			}));
			dangerListField.button = "Neue Gefährdung hinzufügen";
			dangerListField.emptyMessage = "Es wurden noch keine Gefährdungen erfasst.";
		}
		return {
			fieldsets: currentFieldsets,
		};
	}, [dangerListField, currentFieldsets]);

	return res;
};
